"use strict";

module.exports = function ($stateProvider) {
  $stateProvider.state("dashboard.departments.department.tasks.task", {
    url: "/:taskId",
    templateUrl: "dashboard-task/dashboard-task.html",
    controller: "dashboardTaskCtrl as ctrl",
    resolve: {
      task: [
        "$stateParams",
        "Department",
        "$state",
        function ($stateParams, Department, $state) {
          if ($stateParams.taskId === "new") {
            return;
          }

          return Department.task({
            id: $stateParams.departmentId,
            filter: {
              include: [
                "member",
                "form",
                "client",
                {
                  relation: "item",
                  scope: {
                    fields: [
                      "_createdAt",
                      "_startedAt",
                      "closedAt",
                      "id",
                      "taskId",
                      "deptId",
                    ],
                  },
                },
              ],
              where: {
                id: $stateParams.taskId,
              },
            },
          }).$promise.then(function (task) {
            if (!task.length) {
              return null;
            }
            return task[0];
          });
        },
      ],
    },
    data: {
      authorizedRoles: ["admin", "owner", "supervisor", "fieldAdmin"],
    },
  });
};
